import React, { useEffect, useState } from 'react'
import { Redirect, useParams } from 'react-router-dom'

import TriviaQuiz from './views/TriviaQuiz/TriviaQuiz'
import LeadForm from './views/LeadForm/LeadForm'
import Memory from './views/Memory/Memory'
import FindPair from './views/FindPair/FindPair'
import HiddenObjects from './views/HiddenObjects/HiddenObjects'
import PersonalityQuiz from './views/PersonalityQuiz/PersonalityQuiz'
import Puzzle from './views/Puzzle/Puzzle'
import TreasureHunt from './views/TreasureHunt/TreasureHunt'
import Cookies from './views/Cookies/Cookies'
import Horoscope from './views/Horoscope/Horoscope'

import BLOCK from 'common/constants/BlockTypes/BlocksEnum'
import { getBlockFromProjectStructureById } from 'utils/getBlocksFromStructure.js'

const viewsComponents = {
    [BLOCK.quiz]: TriviaQuiz,
    [BLOCK.leadForm]: LeadForm,
    [BLOCK.memoryCards]: Memory,
    [BLOCK.findPair]: FindPair,
    [BLOCK.hiddenObjects]: HiddenObjects,
    [BLOCK.personalityQuiz]: PersonalityQuiz,
    [BLOCK.puzzle]: Puzzle,
    [BLOCK.treasureHunt]: TreasureHunt,
    [BLOCK.cookies]: Cookies,
    [BLOCK.horoscope]: Horoscope,
}

const BlocksLayout = ({ project }) => {
    const { projectId, blockId } = useParams()

    const getBlock = () => getBlockFromProjectStructureById(project.projectStructureJson, blockId)

    const [block, setBlock] = useState(() => getBlock())

    useEffect(() => {
        setBlock(getBlock())
    }, [blockId, project])

    if (!block || !viewsComponents.hasOwnProperty(block.t)) {
        return <Redirect to={`/my-projects/${projectId}/analytics`} />
    }

    const ViewComponent = viewsComponents[block.t]

    return <ViewComponent key={block.id} project={project} block={block} />
}

export default BlocksLayout
